import { WorkflowService } from "./workflow.service";

export const WorkflowServiceFactory = () => {
    const workflow = new WorkflowService();
    // workflow.wguPolicyAcknowledge = false;
    // Preserve workflow 
    return workflow;
};

export const WorkflowServiceProvider = {
    provide: WorkflowService,
    useFactory: WorkflowServiceFactory,
}